import { Box, Card, Grid, Hidden, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { SearchTextField } from "../lib";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";

function UserAuswahl({ client, accessToken, updateTitle, location}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {showErrorMessage} = useMessage();
    const [filter,setFilter]=useState("")
    const [user,setUser]=useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        updateTitle("Mitarbeiter Abwesenheit")
        setIsLoading(true);
        const payload={
          "mandant": client,
          "program": "PMURB3",
          "statement": "UEBERSICHT",
        }
        const headers={
          "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, uebersichtCallback);
        // eslint-disable-next-line
      }, [])

    const uebersichtCallback=(response)=>{
        setIsLoading(false);
        if (response.status === 200) {
          if (response.data.user) {
            setUser(response.data.user);
          }
        } else {
          if (response) {
            showErrorMessage(response.data.message);
          } else {
            showErrorMessage(t("Keine Internetverbindung"));
          }
        }
      }

    function onUserClick(userId){
        navigate("/PMURB3/PMURA1?userId="+userId)
    }

    if (isLoading) {
        return <LoadingComponent path={location}/>
    }

    return(
        <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} md="6">
                <Card>
                    <Box p={2}>
                        <SearchTextField
                            size="small"
                            fullWidth
                            label={t("Suche")}
                            id="filter"
                            variant="outlined"
                            value={filter}
                            inputProps={{
                                autoCapitalize: 'off',
                                autoCorrect: 'off',
                                spellCheck: 'false',
                                autoComplete: 'off'
                            }}
                            onChange={(e)=>setFilter(e.target.value)}
                        />
                    </Box>
                    <Box p={2}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <Hidden lgDown>
                                        <TableRow>
                                            <TableCell>{t("ID")}</TableCell>
                                            <TableCell>{t("Name")}</TableCell>
                                            <TableCell>{t("Aktion")}</TableCell>
                                        </TableRow>
                                    </Hidden>
                                </TableHead>
                                <TableBody>
                                {user&&user.length>0&&user.filter((item) => {
                                    if (item.name.toLowerCase().includes(filter.toLowerCase())===false) return false;
                                    return true;
                                }).map((item,index)=>{
                                    return(
                                    <TableRow
                                        key={item.id}
                                        style={{cursor: 'pointer'}}
                                        onClick={() => onUserClick(item.id) }
                                        hover
                                    >
                                        <Hidden lgDown>
                                            <TableCell>{item.id}</TableCell>
                                            <TableCell>{item.name}</TableCell>
                                            <TableCell>{item.kz==="G"?t("Abwesenheit erfassen/stornieren"):t("Abwesenheit beantragen")}</TableCell>
                                        </Hidden>
                                        <Hidden lgUp>
                                            <TableCell>
                                            {item.id}<br/>{item.name}<br/>{item.kz==="G"?t("Abwesenheit erfassen/stornieren"):t("Abwesenheit beantragen")}
                                            </TableCell>
                                        </Hidden>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Card>
            </Grid>
        </Grid>
    )
}

export default UserAuswahl;